import merge from 'lodash/merge';
import Apps from 'apps';
import { envSwitch } from 'utils/envUtils';
import en from './common/en.json';
import idID from './common/id-ID.json';
import zhHans from './common/zh-Hans.json';
import ja from './common/ja.json';
import reed902 from './extra/reed902';

export const commonResources = {
  en: { translation: en },
  'id-ID': { translation: idID },
  'zh-Hans': { translation: zhHans },
  ja: { translation: ja },
};

export const extraResources = envSwitch([
  [Apps.Reed902, reed902],
], {} as any);

export const resources = merge(commonResources, extraResources);
